import { render, staticRenderFns } from "./PersonalInformation_20230904.vue?vue&type=template&id=310812ac&scoped=true&"
import script from "./PersonalInformation_20230904.vue?vue&type=script&lang=js&"
export * from "./PersonalInformation_20230904.vue?vue&type=script&lang=js&"
import style0 from "./PersonalInformation_20230904.vue?vue&type=style&index=0&id=310812ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310812ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
